import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TableModule } from 'primeng/table'
import { ButtonModule } from 'primeng/button'
import { TooltipModule } from 'primeng/tooltip'
import { InputTextModule } from 'primeng/inputtext'
import { SortMeta } from 'primeng/api'
import { MultiSelectModule } from 'primeng/multiselect'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'app-table',
  template: `
    <div class="card">
      <div class="card-body">
        <div class="table-header-container" style="padding-bottom: 1rem">
          <div>
            <span class="text-small-roman"> {{ title }} </span>
            <span class="text-small-roman" style="font-weight: bold">{{
              matId
            }}</span>
          </div>
          <p-multiSelect
            [options]="colOptions"
            [(ngModel)]="selectedColumns"
            optionLabel="header"
            selectedItemsLabel="{0} columns selected"
            [style]="{ 'min-width': '200px' }"
            placeholder="Choose Columns"></p-multiSelect>
          <div style="display: flex; gap: 1.5rem;">
            <p-button
              class="secondary-btn"
              [rounded]="true"
              label="Reset sorting"
              [outlined]="true"
              severity="help">
              <ng-template pTemplate="icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.13843 6.75101L8.19576 5.80768L11.3338 2.66968L14.4718 5.80768L13.5291 6.75101L12.0004 5.22234V12.667H10.6671V5.22234L9.13843 6.75101Z"
                    fill="#8A00E5" />
                  <path
                    d="M3.99996 10.7779V3.33328H5.33396V10.7779L6.86196 9.24928L7.8053 10.1919L4.6673 13.3299L1.5293 10.1919L2.47196 9.24928L3.99996 10.7779Z"
                    fill="#8A00E5" />
                </svg>
              </ng-template>
            </p-button>
            <p-button
              class="secondary-btn"
              [rounded]="true"
              label="Reset filtering"
              (click)="dt.reset()"
              [outlined]="true"
              severity="help">
              <ng-template pTemplate="icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.31998 9.33333L1.33398 2H14.6673L8.66732 9.33333V14H7.33398V9.33333H7.31998ZM11.854 3.33333H4.14398L7.95332 8H8.03598L11.854 3.33333Z"
                    fill="#8A00E5" />
                </svg>
              </ng-template>
            </p-button>
            <p-button
              class="secondary-btn"
              [rounded]="true"
              label="Download csv"
              (click)="dt.exportCSV()"
              [outlined]="true"
              severity="help">
              <ng-template pTemplate="icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.5727 6.15333L12.426 7.18L7.99935 10.8667L3.57268 7.18L4.42602 6.15333L7.33268 8.58V2H8.66602V8.58L11.5727 6.15333Z"
                    fill="#8A00E5" />
                  <path
                    d="M13.3327 14V12.6667H2.66602V14H13.3327Z"
                    fill="#8A00E5" />
                </svg>
              </ng-template>
            </p-button>
          </div>
        </div>
        <p-table
          #dt
          [columns]="selectedColumns"
          [value]="data"
          dataKey="id"
          styleClass="p-datatable-striped"
          [tableStyle]="{ 'min-width': '50rem' }"
          [paginator]="true"
          [rows]="50"
          [scrollable]="true"
          styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
          sortMode="multiple"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="[50, 100, 150, { showAll: 'All' }]"
          [scrollable]="true"
          (onRowExpand)="handleRowExpanded($event)"
          [multiSortMeta]="multiSortMeta"
          scrollHeight="53vh">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th
                class="table-header text-small-strong"
                *ngFor="let col of columns"
                pSortableColumn="{{ col.field }}">
                <div style="display: flex; align-items: center">
                  {{ col.header }}
                  <p-sortIcon
                    [field]="col.field"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                    class="mr-auto"></p-sortIcon>

                  <p-columnFilter
                    type="text"
                    display="menu"
                    style="margin-left: 1rem"
                    [field]="col.field"></p-columnFilter>
                </div>
              </th>
            </tr>
          </ng-template>
          @if(showQuoteTable){
          <ng-template
            pTemplate="body"
            let-rowData
            let-columns="columns"
            let-expanded="expanded">
            <tr class="text-small-roman">
              <td
                *ngFor="let col of columns"
                [ngStyle]="{
                  'text-align': col.align === 'right' ? 'right' : 'left'
                }">
                @if (col.field === 'CONVERSION_RATE_EURO__C' || col.field ===
                'K_PRICE_C'|| col.field === 'NET_UNIT_PRICE_EURO__C' ||
                col.field === 'TA_PRICE__C') {
                {{ rowData[col.field] | number : '1.2-2' }}
                } @else if (col.field === 'NETPR_EUR' || col.field ===
                'NETWR_EUR') {
                {{
                  rowData[col.field]
                    ? (
                        rowData[col.field]
                        | currency : 'EUR' : 'symbol-narrow' : '1.2-2'
                      )?.replace('€', '') + ' €'
                    : ''
                }}
                } @else if (col.field === 'SUBMITTEDDATE__C' || col.field ===
                'CREATEDDATE') {
                {{ rowData[col.field] | date : 'mediumDate' }}
                } @else {
                {{ rowData[col.field] }}
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td style="border: none;" colspan="5">
                No results for your search terms.
              </td>
            </tr>
          </ng-template>
          } @else {
          <ng-template
            pTemplate="body"
            let-rowData
            let-columns="columns"
            let-expanded="expanded">
            <tr class="text-small-roman">
              <td
                *ngFor="let col of columns"
                [ngStyle]="{
                  'text-align': col.align === 'right' ? 'right' : 'left'
                }">
                @if (col.field === 'EXCHANGE_RATE' || col.field === 'NETWR') {
                {{ rowData[col.field] | number : '1.2-2' }}
                } @else if (col.field === 'NETPR_EUR' || col.field ===
                'NETWR_EUR') {
                {{
                  rowData[col.field]
                    ? (
                        rowData[col.field]
                        | currency : 'EUR' : 'symbol-narrow' : '1.2-2'
                      )?.replace('€', '') + ' €'
                    : ''
                }}
                } @else if (col.field === 'VBELN') {

                <a href="" [pRowToggler]="rowData" class="sales-link"
                  >{{ rowData[col.field] }}
                </a>
                } @else {
                {{ rowData[col.field] }}
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-product>
            <tr>
              <td colspan="7">
                <div class="p-3">
                  <p-table
                    [value]="quoteDetail"
                    dataKey="id"
                    [loading]="loading">
                    <ng-template pTemplate="header">
                      <tr>
                        <th
                          class="table-header text-small-strong"
                          *ngFor="let col of orderDetailsCols"
                          pSortableColumn="{{ col.field }}">
                          <div style="display: flex; align-items: center">
                            {{ col.header }}
                          </div>
                        </th>
                      </tr>
                    </ng-template>

                    <ng-template
                      pTemplate="body"
                      let-rowData
                      let-expanded="expanded">
                      <tr class="text-small-roman">
                        <td
                          *ngFor="let col of orderDetailsCols"
                          [ngStyle]="{
                            'text-align':
                              col.align === 'right' ? 'right' : 'left'
                          }">
                          @if (col.field === 'EXCHANGE_RATE' || col.field ===
                          'NETWR') {
                          {{ rowData[col.field] | number : '1.2-2' }}
                          } @else if (col.field === 'NETPR_EUR' || col.field ===
                          'NETWR_EUR') {
                          {{
                            rowData[col.field]
                              ? (
                                  rowData[col.field]
                                  | currency : 'EUR' : 'symbol-narrow' : '1.2-2'
                                )?.replace('€', '') + ' €'
                              : ''
                          }}
                          } @else {
                          {{ rowData[col.field] }}
                          }
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="6">
                          There are no details for this order.
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </td>
            </tr></ng-template
          >

          <ng-template pTemplate="emptymessage">
            <tr>
              <td style="border: none;" colspan="5">
                No results for your search terms.
              </td>
            </tr>
          </ng-template>
          }
        </p-table>
      </div>
    </div>
  `,
  styles: [
    `
      .table-header {
        background-color: #cf9bff40;
        padding: 0.5rem 0.75rem;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        white-space: nowrap;
      }

      .sales-link {
        color: #8a00e5;
        cursor: pointer;
      }

      .text-small-strong {
        color: #8a00e5 !important;
      }

      td {
        border-right: 1px solid #969696;
      }

      .table-header-container {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
      }
    `,
  ],
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    TooltipModule,
    InputTextModule,
    MultiSelectModule,
    FormsModule,
  ],
})
export class TableComponent {
  public title = ''
  public showQuoteTable = false
  public matId = '-'
  public data: any = {}
  public selectedColumns: any = []
  public colOptions: any = []

  cols: any[] = [
    { field: 'MANDT', header: 'SAP Client', align: 'default' },
    { field: 'NAME1', header: 'Client Name', align: 'default' },
    { field: 'LAND1', header: 'Client Country', align: 'default' },
    { field: 'VBELN', header: 'Sales Order', align: 'default' },
    { field: 'POSNR', header: 'Sales Order Item', align: 'default' },
    { field: 'MATNR', header: 'AP9 Material ID', align: 'default' },
    {
      field: 'MAPPED_MATNR',
      header: 'PS1 Material ID',
      align: 'default',
    },
    { field: 'ARKTX', header: 'Material Description', align: 'default' },
    { field: 'NETWR', header: 'Net Value', align: 'right' },
    { field: 'WAERK', header: 'Document Currency', align: 'default' },
    { field: 'WERKS', header: 'Plant', align: 'default' },
    { field: 'ERDAT', header: 'Document Creation Date', align: 'default' },
    { field: 'NETPR', header: 'Net Price', align: 'right' },
    { field: 'KWMENG', header: 'Quantity', align: 'default' },
    { field: 'EXCHANGE_RATE', header: 'Exchange Rate', align: 'right' },
    { field: 'NETPR_EUR', header: 'Net Price (EUR)', align: 'right' },
    { field: 'NETWR_EUR', header: 'Net Value (EUR)', align: 'right' },
  ]

  orderDetailsCols: any[] = [
    { field: 'MANDT', header: 'SAP Client', align: 'default' },
    { field: 'VBELN', header: 'Sales Order', align: 'default' },
    { field: 'POSNR', header: 'Sales Order Item', align: 'default' },
    { field: 'VBELV', header: 'Reference Doc', align: 'default' },
    { field: 'POSNV', header: 'Reference Doc Item', align: 'default' },
    {
      field: 'MAPPED_MATNR',
      header: 'PS1 Material ID',
      align: 'default',
    },
    { field: 'MATNR', header: 'AP9 Material ID', align: 'default' },
    { field: 'ARKTX', header: 'Material Description', align: 'default' },
    { field: 'NETPR', header: 'Net Price', align: 'right' },
    { field: 'KWMENG', header: 'Quantity', align: 'default' },
    { field: 'NETWR', header: 'Net Value', align: 'right' },
    { field: 'WAERK', header: 'Currency', align: 'default' },
    { field: 'WERKS', header: 'Plant', align: 'default' },
    { field: 'ERDAT', header: 'Creation Date', align: 'default' },
    { field: 'VBTYP_V', header: 'Reference Doc Type', align: 'default' },
  ]

  quoteHistoryCols: any[] = [
    { field: 'SBQQ__QUOTE__C', header: 'Quote ID', align: 'default' },
    { field: 'REF_QUOTE', header: 'Quote', align: 'default' },
    { field: 'SBQQ__NUMBER__C', header: 'Quote Line', align: 'default' },
    { field: 'TA_PRICE__C', header: 'TA Price', align: 'default' },
    { field: 'K_PRICE__C', header: 'K Price', align: 'default' },
    { field: 'PART_NAME__C', header: 'Part Name', align: 'default' },
    {
      field: 'SBQQ__DESCRIPTION__C',
      header: 'Part Description',
      align: 'default',
    },
    { field: 'SBQQ__NETPRICE__C', header: 'Net Price', align: 'default' },
    { field: 'CURRENCYISOCODE', header: 'Net Price Currency', align: 'default' },
    {
      field: 'NET_UNIT_PRICE_EURO__C',
      header: 'Net Unit Price (EURO)',
      align: 'default',
    },
    {
      field: 'CONVERSION_RATE_EURO__C',
      header: 'Quote Conversion Rate',
      align: 'default',
    },
    { field: 'SBQQ__QUANTITY__C', header: 'Quantity', align: 'default' },
    { field: 'UOM__C', header: 'Unit of Measure', align: 'default' },
    { field: 'SBQQ__NETTOTAL__C', header: 'Net Total', align: 'default' },
    {
      field: 'SBQQ__LISTPRICE__C',
      header: 'List Price',
      align: 'default',
    },
    {
      field: 'TRUE_EBIT_PERCENT__C',
      header: 'True EBIT %',
      align: 'default',
    },
    { field: 'SBQQ__ACCOUNT__C', header: 'Customer Account', align: 'default' },
    { field: 'ACCOUNT_NAME__C', header: 'Customer Name', align: 'default' },
    { field: 'SUBMITTEDDATE__C', header: 'Submitted Date', align: 'default' },
    { field: 'CREATEDDATE', header: 'Created Date', align: 'default' },
    { field: 'INCOTERMS__C', header: 'Incoterms', align: 'default' },
  ]

  multiSortMeta: SortMeta[] = [{ field: 'ERDAT', order: -1 }]

  @Input()
  set tableTitle(title: string) {
    this.title = title
  }

  @Input()
  set showQuoteHistory(showQuoteTable: boolean) {
    this.showQuoteTable = showQuoteTable
  }

  @Input()
  set materialId(id: string) {
    this.matId = id
  }

  @Input()
  set tableData(data: any) {
    this.data = data
    this.selectedColumns = this.showQuoteTable
      ? this.quoteHistoryCols
      : this.cols
    this.colOptions = this.showQuoteTable
    ? this.quoteHistoryCols
    : this.cols
  }

  @Input() quoteDetail: any
  @Input() loading: any

  @Output() onRowExpanded: EventEmitter<any> = new EventEmitter<any>()

  handleRowExpanded(event: any) {
    this.onRowExpanded.emit(event)
    console.log('')
  }
}
